import React from 'react';
import { getQaKey as qa } from '../../util/qa';
import AlertIcon from '../icons/AlertIcon';
import useStyles from '../../hooks/useStyles';
import { string, bool } from 'prop-types';

FormError.propTypes = {
	error: string,
	hideIcon: bool
};

/**
 * Inline error component to display error messages in a form.
 *
 * This will typically be used to display errors relating to failed service calls after
 * submission of a form.
 */
export default function FormError({ error, hideIcon }) {
	const classes = useStyles(styles);
	return error ? (
		<p css={classes.root} {...qa('form:error')}>
			{!hideIcon && <AlertIcon css={classes.icon} />}
			<span>{error}</span>
		</p>
	) : (
		false
	);
}

function styles({ css, theme: { color } }) {
	return {
		root: css`
			position: relative;
			margin: 16px 0;
			border-radius: 4px;
			color: ${color.danger};
			height: 16px;
			display: flex;
			align-items: center;
		`,
		icon: css`
			width: 24px;
			margin-right: 8px;
			fill: ${color.danger};
			flex: 0 0 auto;
		`
	};
}
